module.exports = __webpack_public_path__ + "static/media/logo-rafa-white.4f1845a1.png";